import axios from 'axios';
import { REUPLOADLAPIHOME } from './config';
import OrgDataDef from '../sections/JJMIUser/orgdatadef';

class OrgReuploadService {

    constructor() {

        this.GetColumns = (menuName) => (OrgDataDef(menuName));

        this.NewReupload = (payload) => (axios.post(`${REUPLOADLAPIHOME}newreupload`, payload));

        this.IsReuploadEnabled = (payload) => (axios.post(`${REUPLOADLAPIHOME}isreuploadenabled`, payload));

        this.GetFranchiseByDistId = (distributorId) => (axios.post(`${REUPLOADLAPIHOME}getfranchisebydistid`, { distributorId }));

        this.GetFranchiseByUploadTrack = (payload) => (axios.post(`${REUPLOADLAPIHOME}getfranchisebyuploadtrack`, payload));

        this.GetAllFranchise = () => (axios.post(`${REUPLOADLAPIHOME}getallfranchise`, null));

        this.GetReuploadByFranchise = (payload) => (axios.post(`${REUPLOADLAPIHOME}getreuploadbyfranchise`, payload));
    }
}
export default new OrgReuploadService();